import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingBranchPlaceholder = (props: any) => {
  const { t } = useTranslation();
  return (
    <Placeholder
      placeholderText={t('You cannot add Branches to a loop.')}
      {...props}
    />
  );
};

export default MovingBranchPlaceholder;
